import { render, staticRenderFns } from "./system-config.vue?vue&type=template&id=6b85ad4e&scoped=true"
import script from "./system-config.vue?vue&type=script&lang=js"
export * from "./system-config.vue?vue&type=script&lang=js"
import style0 from "./system-config.vue?vue&type=style&index=0&id=6b85ad4e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b85ad4e",
  null
  
)

export default component.exports